import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
export type BaseNodeButtonColor = 'accent' | 'primary' | 'info' | 'success' | 'warning' | 'error';
export type NodeIconProps = {
  Icon: Icon;
  color: BaseNodeButtonColor;
};
const iconBgColor: Record<BaseNodeButtonColor, string> = {
  accent: 'bg-quaternary/40',
  primary: 'bg-senary',
  info: 'bg-info',
  success: 'bg-success',
  warning: 'bg-warning',
  error: 'bg-error'
};
const NodeIcon = props => {
  const $ = _c(8);
  const t0 = iconBgColor[props.color];
  let t1;
  if ($[0] !== t0) {
    t1 = cx("flex flex-shrink-0 justify-center items-center size-10 rounded-[6px]", t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props.Icon || $[3] !== props.color) {
    t2 = <props.Icon color={props.color} />;
    $[2] = props.Icon;
    $[3] = props.color;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default NodeIcon;